var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"px-1",attrs:{"for":"forLabel"}},[_c('span',{staticClass:"font-weight-medium textColor--text"},[_vm._v(_vm._s(_vm.label))]),_c('span',{staticClass:"asterix px-1"},[_vm._v("*")])])}
var staticRenderFns = []

export { render, staticRenderFns }